

function Customer2FaTag(config = {step:"",tipo_origem:"",nome_item:"",nome_secao:"",nome_campo:"",tipo_callback:"",nome_modal:"",tipo_erro:""}) {

return {
    "customer2fa":{
        "default":{
            "custom_section":`minha_claro_credencial:autenticacao_${config?.tipo_origem}`,

        },
        "error":{
            "custom_title": `autenticacao`,
            "custom_callback": `erro:${config?.tipo_erro}:${config?.tipo_callback}`
        },
        "success":{
      
            "custom_title": `autenticacao`,
            "custom_callback": `sucesso:${config?.tipo_callback}`
        },
        "pageview":{"title":`2FA - ${config?.step}`},
   
         "footer": {
            "custom_section":`minha_claro_credencial:geral_${config?.tipo_origem}`,
            "custom_title": `footer:${config?.nome_item}`
        },
         "click-item":{
            "custom_title": `${config?.nome_secao}:${config?.nome_item}`
        },
        "input-item":{
            "custom_title": `preencheu:${config?.nome_item}`
        },

        "click-item-modal":{
            "custom_title": `${config?.nome_modal}:${config?.nome_item}`
        },
        
        
}
}
}
export default Customer2FaTag;
